module.exports = __webpack_public_path__ + "static/media/cell.c392b0c2.png";